{
  "cc-permissions.access-links-changeboarding.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "cc-permissions.access-links-changeboarding.check-it-out": [
    {
      "type": 0,
      "value": "Check it out"
    }
  ],
  "cc-permissions.access-links-changeboarding.configure-description": [
    {
      "type": 0,
      "value": "Manage your allowed access levels, permissions, and content types."
    }
  ],
  "cc-permissions.access-links-changeboarding.configure-title": [
    {
      "type": 0,
      "value": "Configure access links"
    }
  ],
  "cc-permissions.access-links-changeboarding.description": [
    {
      "type": 0,
      "value": "Public links have evolved to support more flexible ways of sharing content."
    }
  ],
  "cc-permissions.access-links-changeboarding.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "cc-permissions.access-links-changeboarding.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "cc-permissions.access-links-changeboarding.more-ways-description": [
    {
      "type": 0,
      "value": "You can now share content with licensed Confluence users on your app without granting them space access."
    }
  ],
  "cc-permissions.access-links-changeboarding.more-ways-title": [
    {
      "type": 0,
      "value": "More ways to share content"
    }
  ],
  "cc-permissions.access-links-changeboarding.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "cc-permissions.access-links-changeboarding.public-links-disabled-description": [
    {
      "type": 0,
      "value": "Public links are now a type of access link. Allow them to share content with anyone on the internet."
    }
  ],
  "cc-permissions.access-links-changeboarding.public-links-enabled-description": [
    {
      "type": 0,
      "value": "Public links are now a type of access link. Your existing settings remain unchanged."
    }
  ],
  "cc-permissions.access-links-changeboarding.public-links-title": [
    {
      "type": 0,
      "value": "Public links are still here"
    }
  ],
  "cc-permissions.access-links-changeboarding.step-count": [
    {
      "type": 0,
      "value": "Step "
    },
    {
      "type": 1,
      "value": "step"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "cc-permissions.access-links-changeboarding.title": [
    {
      "type": 0,
      "value": "Public links are now access links"
    }
  ],
  "cc-permissions.confluence-exco-added-to-space.message-template.email.gday": [
    {
      "type": 0,
      "value": "G'day"
    }
  ],
  "cc-permissions.confluence-exco-added-to-space.message-template.email.header.external-info": [
    {
      "type": 0,
      "value": "Guests may be external to your organization."
    }
  ],
  "cc-permissions.confluence-exco-no-space-access.message-template.email.more-message": [
    {
      "type": 0,
      "value": "And more. Select "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Manage access"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to get a full list."
    }
  ],
  "cc-permissions.confluence-exco-space-ready.message-template.email.external-info": [
    {
      "type": 0,
      "value": "Guests may be external to your organization."
    }
  ],
  "cc-permissions.confluence-exco-space-ready.message-template.email.secondary-cta": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "cc-permissions.confluence-exco-user-requested-access.message-template.email.guest-profile.guest-badge": [
    {
      "type": 0,
      "value": "GUEST"
    }
  ],
  "cc-permissions.confluence-exco-user-requested-access.message-template.email.header.text": [
    {
      "type": 0,
      "value": "The following guest has requested access to your Confluence site: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". Guests need access to a space before they can use Confluence at all."
    }
  ],
  "confluence.confluence-public-link-page-enabled.message-template.email.access-link.subject": [
    {
      "type": 0,
      "value": "An access link has been turned on for a content in "
    },
    {
      "type": 1,
      "value": "spaceName"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.avatar": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.content-space-and-site.access-link": [
    {
      "type": 0,
      "value": "This content is in the "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "spaceName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " space on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.description-of-access-link-feature.external": [
    {
      "type": 0,
      "value": "An access link has been turned on for this content – this lets anyone on the internet with the link view this content while the link is active."
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.description-of-access-link-feature.internal-licensed": [
    {
      "type": 0,
      "value": "An access link has been turned on for this content – this lets all licensed Confluence users on your site with the link view this content while the link is active."
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.learn-more-about-access-links": [
    {
      "type": 0,
      "value": "Learn more about access links"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.live-doc": [
    {
      "type": 0,
      "value": "View doc"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.page": [
    {
      "type": 0,
      "value": "View page"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.slide": [
    {
      "type": 0,
      "value": "View slide"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.whiteboard": [
    {
      "type": 0,
      "value": "View whiteboard"
    }
  ],
  "confluence.confluence-public-link-page-enabled.test-message.email.body.summary.access-link": [
    {
      "type": 1,
      "value": "pageLinkEnabler"
    },
    {
      "type": 0,
      "value": " turned on an access link for "
    },
    {
      "type": 1,
      "value": "contentTitle"
    }
  ],
  "confluence.confluence-public-link-space-enabled.message-template.email.subject.external": [
    {
      "type": 0,
      "value": "Access links are now allowed in your Confluence space"
    }
  ],
  "confluence.confluence-public-link-space-enabled.message-template.email.subject.internal-licensed": [
    {
      "type": 0,
      "value": "Access links are now allowed in your Confluence space"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.avatar": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.description.external": [
    {
      "type": 0,
      "value": "This update doesn't change any existing user access. It simply enables users in this space to share content with anyone on the internet using access links."
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.description.internal-licensed": [
    {
      "type": 0,
      "value": "This update doesn't change any existing user access. It simply enables users in this space to share content more broadly with all licensed Confluence users on your site using access links."
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.learn-more-about-access-links": [
    {
      "type": 0,
      "value": "Learn more about access links"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.manage-access-links-cta": [
    {
      "type": 0,
      "value": "Manage access links"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.space-header": [
    {
      "type": 0,
      "value": "Confluence space"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.title.external": [
    {
      "type": 0,
      "value": "People in your space can now use access links"
    }
  ],
  "confluence.confluence-public-link-space-enabled.test-message.email.body.who-made-the-change": [
    {
      "type": 0,
      "value": "Who made the change"
    }
  ],
  "confluence.confluence-public-links-site-enabled.message-template.email.subject.external": [
    {
      "type": 0,
      "value": "Access links are now allowed on your Confluence site"
    }
  ],
  "confluence.confluence-public-links-site-enabled.message-template.email.subject.internal-licensed": [
    {
      "type": 0,
      "value": "Access links are now allowed in your Confluence site"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.avatar": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.header.external": [
    {
      "type": 0,
      "value": "People in your site can now use access links"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.learn-more-about-access-links": [
    {
      "type": 0,
      "value": "Learn more about access links"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.manage-access-links-cta": [
    {
      "type": 0,
      "value": "Manage access links"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.site-name": [
    {
      "type": 0,
      "value": "Confluence site"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.subtext.external": [
    {
      "type": 0,
      "value": "This update doesn't change any existing user access. It simply enables users in spaces where access links are allowed to share content with anyone on the internet."
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.subtext.internal-licensed": [
    {
      "type": 0,
      "value": "This update doesn't change any existing user access. It simply enables users in spaces where access links are allowed to share content more broadly with all licensed Confluence users on your site."
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.system.subtext.updated": [
    {
      "type": 0,
      "value": "Access links let users share Confluence content with all licensed Confluence users on your site, across your unit, or publicly with anyone on the internet."
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.upgrade.description.updated": [
    {
      "type": 0,
      "value": "Access links are only available on paid plans and are allowed by default. This default was activated when your plan was upgraded."
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.body.who-made-the-change": [
    {
      "type": 0,
      "value": "Who made the change"
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.system.body.header.updated": [
    {
      "type": 0,
      "value": "People in your site can now use access links because your Confluence plan was upgraded."
    }
  ],
  "confluence.confluence-public-links-site-enabled.test-message.email.system.body.site-name": [
    {
      "type": 0,
      "value": "Confluence site"
    }
  ],
  "confluence.email.external-collab-guest-added.gday.greeting": [
    {
      "type": 0,
      "value": "G'day "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "username"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "confluence.notifications.exco.space.ready.subject": [
    {
      "type": 0,
      "value": "[Confluence] "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " has invited you to join Confluence as a guest"
    }
  ],
  "email.immediate.cta.space.learn_more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "email.immediate.cta.space.manage_access": [
    {
      "type": 0,
      "value": "Manage access"
    }
  ],
  "email.immediate.external_collab.guest.permission.footer": [
    {
      "children": [
        {
          "type": 0,
          "value": "Note: "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Your admin may further restrict your functionality from these default settings."
    }
  ],
  "email.immediate.external_collab.guest.permission.header": [
    {
      "type": 0,
      "value": "As a guest, you can:"
    }
  ],
  "email.immediate.external_collab.guest.permission.row.five": [
    {
      "type": 0,
      "value": "Mention other people"
    }
  ],
  "email.immediate.external_collab.guest.permission.row.four": [
    {
      "type": 0,
      "value": "See other people's profiles"
    }
  ],
  "email.immediate.external_collab.guest.permission.row.one": [
    {
      "type": 0,
      "value": "View, create, and edit in this space"
    }
  ],
  "email.immediate.external_collab.guest.permission.row.three": [
    {
      "type": 0,
      "value": "View and collaborate in other spaces"
    }
  ],
  "email.immediate.external_collab.guest.permission.row.two": [
    {
      "type": 0,
      "value": "Leave comments in this space"
    }
  ],
  "email.immediate.external_collab.guest.primary.cta": [
    {
      "type": 0,
      "value": "Join as a guest"
    }
  ],
  "email.immediate.external_collab.guest_added_to_your_space.header.text": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "A guest has been added to your space by "
            },
            {
              "type": 1,
              "value": "originatorName"
            },
            {
              "type": 0,
              "value": "."
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "guestCount"
            },
            {
              "type": 0,
              "value": " guests have been added to your space by "
            },
            {
              "type": 1,
              "value": "originatorName"
            },
            {
              "type": 0,
              "value": "."
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "guestCount"
    }
  ],
  "email.immediate.external_collab.guest_added_to_your_space.subject": [
    {
      "type": 0,
      "value": "[Confluence] "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "A guest has been added to your space"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "guestCount"
            },
            {
              "type": 0,
              "value": " guests have been added to your space"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "guestCount"
    }
  ],
  "email.immediate.external_collab.guest_request_access.subject": [
    {
      "type": 0,
      "value": "[Confluence] A guest has requested access to your site"
    }
  ],
  "email.immediate.external_collab.no_space_access.header.text": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "A guest"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "displayCount"
            },
            {
              "type": 0,
              "value": " guests"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numGuests"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " need to be assigned a space in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product Settings"
        }
      ],
      "type": 8,
      "value": "productSettingsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "email.immediate.external_collab.no_space_access.subject": [
    {
      "type": 0,
      "value": "[Confluence] ACTION REQUIRED: "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "A guest needs access to Confluence"
            }
          ]
        },
        "other": {
          "value": [
            {
              "options": {
                "25": {
                  "value": [
                    {
                      "type": 0,
                      "value": "25+ guests need access to Confluence"
                    }
                  ]
                },
                "other": {
                  "value": [
                    {
                      "type": 1,
                      "value": "numGuests"
                    },
                    {
                      "type": 0,
                      "value": " guests need access to Confluence"
                    }
                  ]
                }
              },
              "type": 5,
              "value": "numGuests"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numGuests"
    }
  ],
  "email.immediate.external_collab.space_is_ready.header.text": [
    {
      "type": 1,
      "value": "originatorName"
    },
    {
      "type": 0,
      "value": " has invited you to join the following Confluence space as a guest. Join now to start collaborating!"
    }
  ],
  "email.immediate.space_request_access.subject": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " requested access to your space"
    }
  ],
  "email.immediate.space_request_access.subject.wants_access": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " wants access to your space"
    }
  ]
}